<!-- <ng-container *ngIf="this.isNutritionalPrescription!=null"> -->

<div id={{dataId}}>
    <div class="container-fluid px-3 col-md-12 mt-5 pt-3 egd-prescription">
        <div class="page-break" *ngFor='let prescrip of data.consultation.p_prescriptions; let i = index'>
            <div style="text-align: center;">


                <img [src]="this.logo_url" height="49">
                <h3 class="mt-1" style="text-align: center;  color:#004aad;">
                    {{this.isNutritionalPrescription?'Nutritional Prescription':'Prescription'}}
                </h3>
            </div>
            <div style="text-align: left;">
                Page : {{i+1}} of {{data.consultation.p_prescriptions.length}}
            </div>
            <div style="background-color: #fff;">
                <div class="row">
                    <div class="col-md-6">
                        <table class="table" style="padding-bottom: 0px; border: 0px;">
                            <tbody>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Physician Name:</td>
                                    <td style="text-align: left;border: 0px;">
                                        {{doctor_name}}</td>
                                </tr>
                                <tr *ngIf="this.gmc_reg_no">
                                    <td style="text-align: left; font-weight:600;border: 0px;"><b>Physician GMC
                                            Registration Numbers:</b></td>
                                    <td style="text-align: left;border: 0px;">
                                        {{gmc_reg_no}}
                                    </td>

                                </tr>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Speciality:</td>
                                    <td style="text-align: left;border: 0px;">{{specialty}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6" style="float: none; display: inline; position: static;">

                        <table class="table" style="padding-bottom: 0px; border: 0px;">
                            <tbody>
                                <tr>
                                    <td style="text-align: left; font-weight:600; border: 0px;">Prescription No:</td>
                                    <td style="text-align: left; border: 0px;">{{
                                        data.consultation.prescription_number}}
                                    </td>
                                </tr>
                                <tr>

                                    <td style="text-align: left; font-weight:600;border: 0px;">Prescription Date:</td>
                                    <td style="text-align: left; border: 0px;">
                                        {{ this.DateFormat(data.consultation.consultation_closed_date)}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <hr style="border-style: solid; border-width: 1px;" class="mt-0 mb-0 pt-0 pb-0">
                <div class="row">
                    <div class="col-md-6">
                        <table class="table" style="border: 0px;">
                            <tbody>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Patient's First Name:
                                    </td>
                                    <td style="text-align: left;border: 0px;">
                                        {{data.patient.first_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Patient's Last Name:</td>
                                    <td style="text-align: left;border: 0px;">
                                        {{data.patient.last_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Date of Birth:</td>
                                    <td style="text-align: left;border: 0px;">{{data.patient.date_of_birth}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6">
                        <table class="table" style="float:right;border: 0px;">
                            <tbody>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Age:</td>
                                    <td style="text-align: left;border: 0px;">{{this.page}}</td>
                                </tr>
                                <tr>
                                    <td style="text-align: left; font-weight:600;border: 0px;">Gender:</td>
                                    <td style="text-align: left;border: 0px;">{{this.gender}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <hr style="border-style: solid; border-width: 1px;" class="mt-0 mb-0 pt-0 pb-0">
                <div class="row">

                    <div class="col-md-12" style="text-align: left;">
                        <table style="border: 0px;">
                            <tbody>

                                <ng-container *ngIf="!this.isNutritionalPrescription">
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad; " contenteditable="true"
                                                spellcheckker="false">Medication:</h5>
                                        </td>
                                        <td>
                                            <h6 style=" text-align: left; font-weight: 400;" class="pl-2">
                                                {{prescrip.medication_name}}</h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad;">Dosage:</h5>
                                        </td>
                                        <td>
                                            <h6 style="text-align: left; font-weight: 400;" class="pl-2">
                                                {{prescrip.dosage}}
                                            </h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad;">Times per day:</h5>
                                        </td>
                                        <td>
                                            <h6 style="text-align: left;  font-weight: 400;" class="pl-2">
                                                {{prescrip.times_per_day==null?"N/A":prescrip.times_per_day}}</h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad;" contenteditable="true"
                                                spellcheckker="false">Refills (count):</h5>
                                        </td>
                                        <td>
                                            <h6 style="text-align: left; font-weight: 400;" class="pl-2">
                                                {{prescrip.no_of_refills}}</h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left;  color:#004aad;">Special Instruction: </h5>
                                        </td>
                                        <td>
                                            <h6 style="text-align: left; font-weight: 400;" class="pl-2">
                                                {{prescrip.comments.length==0?"N/A":prescrip.comments}}</h6>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-container *ngIf="this.isNutritionalPrescription;">
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad; " contenteditable="true"
                                                spellcheckker="false">Advice:</h5>
                                        </td>
                                        <td>
                                            <h6 style=" text-align: left; font-weight: 400;" class="pl-2 format-lines">
                                                {{prescrip.advice}}</h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad; " contenteditable="true"
                                                spellcheckker="false">Recommendations:</h5>
                                        </td>
                                        <td>
                                            <h6 style=" text-align: left; font-weight: 400;" class="pl-2 format-lines">
                                                {{prescrip.recommendations}}</h6>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5 style="text-align: left; color:#004aad; " contenteditable="true"
                                                spellcheckker="false">General Instructions:</h5>
                                        </td>
                                        <td>
                                            <h6 style=" text-align: left; font-weight: 400;" class="pl-2 format-lines">
                                                {{prescrip.comments}}</h6>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                            <tbody>
                            </tbody>
                        </table>


                        <hr style="border-style: solid; border-width: 1px;" class="mt-0 mb-0 pt-0 pb-0">
                    </div>

                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-12">
                    <table>
                        <tbody>
                            <div class="col-md-12">
                                <tr>
                                    <td rowspan="2">
                                        <p style="text-align: left; color:#004aad;">Electronically Signed and verified
                                            by:
                                        </p>
                                    </td>
                                    <td style="text-align: left;font-weight: bold;" *ngIf="!isNutritionalPrescription">
                                        <img [src]="data.signature_url" alt="signature"
                                            style="height: 100px; border: 1px solid black;  margin-bottom: 3%; text-align: center;">
                                    </td>
                                    <td style="text-align: left;font-weight: bold;">
                                        {{data.consultation.egd_users.first_name +" "+
                                        (data.consultation.egd_users.middle_name==null?'':data.consultation.egd_users.middle_name)
                                        +" "+
                                        data.consultation.egd_users.last_name}}
                                    </td>
                                </tr>
                            </div>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5 mb-0 pt-0 pb-0">
                    <p style="text-align: left; float: left;" *ngIf="this.is_primary_provider && !is_uk_country">www.eglobaldoctors.com</p>
                    <p style="text-align: left; float: left;" *ngIf="this.is_primary_provider && is_uk_country">www.eglobaldoctors.co.uk</p>
                    <p style="text-align: right; float: right">
                        {{ this.DateFormat(data.consultation.consultation_closed_date)}}</p>
                </div>
            </div>


        </div>
    </div>
    <ng-container *ngIf="this.isGeorgiaPrescription" class="mt-4">
        <div class="sheger-prescription page-break-bf container mt-5">
            <p class="my-3 text-center"><b>Order your medicines from eGlobalDoctor's Pharmacy partners. Pickup available
                    at any address given below.</b></p>
            <div class="row" *ngFor="let pharm of pharmacies">
                <div class="col-md-2 col-sm-4 pr-0">

                    <img class="my-4 ml-4 pharmacy_img" [src]="pharm.egd_pharmacy.pharmacy_logo_url" alt="">

                </div>
                <div class="col-md-6 col-sm-6 pl-0 mt-3">
                    <p><b> {{pharm.egd_pharmacy.address_line_1 + ", " + pharm.egd_pharmacy.address_line_2 || ''}}</b>
                    </p>
                    <p><b>{{pharm.country_states.state_name + ", " + pharm.country.country_name + ", " +
                            pharm.egd_pharmacy.zip_code}}</b></p>
                    <p class="egd-color"><b>{{pharm.egd_pharmacy.phone_number}}</b></p>

                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5 mb-0 pt-0 pb-0">
                    <p style="text-align: left; float: left;" *ngIf="this.is_primary_provider">www.eglobaldoctors.com
                    </p>
                    <p style="text-align: right; float: right">
                        {{ this.DateFormat(data.consultation.consultation_closed_date)}}</p>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="data !=null && this.country_name == 'India' && data.discount_coupon_data != null && data.apolloDiagnosticsCoupon !=null">
        <div class="page-break-bf heading4 text-center mt-4">
            <span>
                <p><b>*Note 1: </b>To buy your medicines at discounted price upto 15%, please walk in to nearest
                    Apollo
                    pharmacy or visit online <a href="https://www.apollopharmacy.in/" target="_blank"><br>(
                        https://www.apollopharmacy.in/ )</a></p>
                <p><b>Coupon Code:</b> {{data.discount_coupon_data.discount_code}} , <b>Corporate Id:
                    </b>{{data.discount_coupon_data.vendor_data.corporate_id}}</p>
            </span>
            <span>
                <p style="margin-top: 7vh;"><b>*Note 2: </b>Use code<b
                        style="padding-left: 5px !important;">{{data.apolloDiagnosticsCoupon.couponId || ''}}</b> to get
                    15% off on diagnostic tests at Apollo Diagnostics <a href="https://www.apollodiagnostics.in"
                        target='_blank'>(https://www.apollodiagnostics.in)</a></p>
            </span>
        </div>
        <div class="row" style="justify-content:center;margin-top: 7vh;">
            <img style="margin-right: 7vw;" src="../../../../assets/images/dashboard/patient/apollo_pharmacy_logo.svg">
            <img src="../../../../assets/images/dashboard/patient/apollo_diagnostics_logo.png">
        </div>
    </ng-container>

</div>
<!-- </ng-container> -->